
import * as Project from "./projectStyles";

import { FaGithub, FaExternalLinkAlt } from "react-icons/fa"


export default function ProjectItemOne({ project }){
    return (
        <>
            <Project.ItemContainer data-aos="fade-up">

                <Project.ItemSnapshotContainer>
                    <Project.ItemSnapshot src={project.photoUrl} />
                </Project.ItemSnapshotContainer>

                <Project.InfoContainer>
                    <Project.FeaturedText>Feature Project</Project.FeaturedText>
                    <Project.ItemName>{project.title}</Project.ItemName>
                    <Project.DescriptionContainer>
                        <Project.DescriptionText>{project.description}</Project.DescriptionText>
                    </Project.DescriptionContainer>
                    <Project.TechnologiesContainer>
                        
                        {project.technologies &&
                            project.technologies.map((item, index) =>
                            <Project.TechnologiesText key={index}>{item}</Project.TechnologiesText>

                        )}
                    </Project.TechnologiesContainer>
                    <Project.LinksContainer>
                        <Project.Link href={project.github} target="_blank"><FaGithub /></Project.Link>
                        {
                            project.website ? 
                            <Project.Link href={project.website} target="_blank"><FaExternalLinkAlt/></Project.Link> : 
                            null
                        }
                    </Project.LinksContainer>
                </Project.InfoContainer>

            </Project.ItemContainer>
        </>

    )
}